<template>
  <article class="flex flex-col">
    <TeacherTitleSlug
      v-if="false"
      :title="lecture.title"
      :highlight-title="highlight.title"
      :highlight-paragraph="highlightParagraph"
      :link-for-back="`/teacher/${$route.params.parent}/${$route.params.category}?content=${lecture.model_type}${groupList}`"
    />
    <div class="mb-[120px] flex gap-[20px]">
      <div class="flex w-full flex-col">
        <div class="grid gap-5 lg:grid-cols-3 xl:grid-cols-4">
          <div class="xl:max-w-full size-full lg:col-span-2 xl:col-span-3">
            <div
              v-if="correctSrc"
              class="aspect-wrap relative w-full overflow-hidden rounded-2xl"
              style="padding-bottom: calc(9 / 16 * 100%)"
            >
              <iframe
                v-lazy-load
                :src="correctSrc"
                width="100%"
                height="100%"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div v-else class="text-[32px] font-medium leading-[38px]">
              Видео не найдено.
            </div>
          </div>
          <div
            v-if="!isLessThanHorizontalPad"
            class="relative col-span-1 size-full max-w-[367px] overflow-y-hidden rounded-[12px] shadow-drop-2 lg:row-span-2 lg:max-h-[694px] xl:row-span-1"
          >
            <CommonBlocksVideoPlayList
              :data="sortedCollection"
              :count="sortedCollection.length"
              :rubrics-title="highlight?.title"
              :active="activeIndex"
              :category-title="categoryTitle"
              class="inset-0 h-full xl:absolute"
              @change-active="handleActiveVideo($event)"
            />
          </div>
          <div class="lg:col-span-2 xl:col-span-4">
            <h2
              v-if="!isLessThanHorizontalPad"
              class="text-[16px] font-medium leading-[24px]"
              v-html="lecture?.body"
            />
            <div
              v-if="isLessThanHorizontalPad"
              class="mb-3 font-roboto text-[14px] font-semibold leading-[17px] text-[#808080]"
            >
              {{ activeIndex + 1 }} видео из {{ sortedCollection?.length }}
            </div>
            <!-- <the-button-new
              v-if="!isLessThanHorizontalPad"
              text="ВСЕ ПЛЕЙЛИСТЫ"
              type="default"
              icon="chevron-left"
              icon-position="left"
              class="mt-12 mb-8 w-full sm:w-fit justify-center max-h-[64px]"
              @click.native="$router.go(-1)"
            /> -->
          </div>
          <template v-if="isLessThanHorizontalPad">
            <CommonBlocksVideoPlayList
              :data="sortedCollection"
              :count="sortedCollection?.length"
              :rubrics-title="highlight?.title"
              :category-title="categoryTitle"
              :active="activeIndex"
              title-disabled
              @change-active="handleActiveVideo($event)"
            />
            <!-- <the-button-new
              text="ВСЕ ПЛЕЙЛИСТЫ"
              type="default"
              icon="chevron-left"
              icon-position="left"
              class="mt-12 mb-8 w-full sm:w-fit justify-center max-h-[64px]"
              @click="
                $router.replace(
                  `teacher/${$route.params.parent}/${$route.params.category}`
                )
              "
            /> -->
            <h2
              class="text-[16px] font-medium leading-[24px]"
              v-html="lecture?.body"
            />
          </template>
        </div>
      </div>
    </div>
    <BaseThematicCollections :data="props.data" />
  </article>
</template>

<script setup>
import api from '@/services/api/api';

definePageMeta({
  layout: 'marginless',
});

const crumbsStore = useBreadcrumbsStore();

const props = defineProps({
  highlight: {
    type: Object,
    default: () => ({}),
  },
  data: {
    type: Array,
    default: () => [],
  },
  category: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:collection']);

const route = useRoute();
const router = useRouter();
const { secondsToISO } = helperSeo();
const slug = route?.params?.slug;
const { lectureSlug } = useLecturesBySlug(slug);
useErrorHandler(() => lectureSlug.failureReason.value?.status);
const { isLessThanHorizontalPad, handleResize } = useBreakpoint();

const lecture = computed(() => lectureSlug?.data?.value);

const groupList = computed(() => {
  if (!route?.query?.group) return '';
  return `&group=${route.query.group}`;
});

const highlightParagraph = computed(() => {
  let highlightIdx;
  props.category?.chapters?.find((item) =>
    item.highlights.find((highlight) => {
      if (highlight.id !== props.highlight?.id) return '';
      highlightIdx = highlight.number;
      return highlight;
    }),
  );
  return highlightIdx ? `§ ${highlightIdx}.` : '';
});

const sortedCollection = computed(() => {
  return props.data; /*?.filter((item) => {
    return item.model_type === 'videolecture';
  });*/
});

const correctSrc = computed(() => {
  if (lecture.value?.video_code?.includes('https')) {
    return lecture.value?.video_code;
  }
  return false;
});

const activeIndex = computed(() => {
  return sortedCollection.value?.findIndex(
    (item) => item.slug === lecture.value?.slug,
  );
});

const categoryTitle = computed(() => {
  return `${props.category?.school_class?.title} класс (${props.category?.title})`;
});

/**mounted */
onMounted(async () => {
  if (props.data?.length === 0) {
    try {
      const slug = route.params.category;
      const { data } = await api.collections.getCollectionItemsBySlug(
        slug,
        'videomaterial',
      );
      emit('update:collection', data?.data ?? []);
    } catch (e) {
      console.log(e);
    }
  }
});

/**methods */
const handleActiveVideo = async (slug) => {
  if (route.params.slug === slug) return;

  await router.replace({
    query: route.query,
    params: {
      ...route.params,
      slug,
    },
  });
  handleResize();
};

/**watch */
watch(
  () => lecture.value,
  (value) => {
    if (!value) return;
  },
  {
    immediate: true,
  },
);

watch(
  lecture,
  (val) => {
    if (!val) return;
    crumbsStore.setCrumbs({
      key: 'slug',
      value: {
        title: lecture.value?.title,
        slug: lecture.value?.slug,
      },
    });
  },
  { immediate: true },
);

onBeforeRouteLeave(() => {
  crumbsStore.setCrumbs({ key: 'slug', value: null });
});

useHead(
  computed(() => ({
    title: `${
      lecture.value?.title ? `${lecture.value.title} |` : ''
    } Материалы по истории для школьного курса «История России» и «Всеобщая история» с 5 по 11 класс`,
    meta: [
      {
        hid: 'og:type',
        property: 'og:type',
        content: 'video.other',
      },
      {
        name: 'ya:ovs:upload_date',
        content: lecture.value?.published_at,
      },
      { name: 'ya:ovs:adult', content: 'no' },
      {
        name: 'video:duration',
        content: lecture.value?.duration?.toString(),
      },
      { property: 'og:video:type', content: 'video/mp4' },
      { property: 'og:title', content: lecture.value?.title },
      {
        property: 'og:url',
        content: `${useHostApp()}${route.path}`,
      },
      { property: 'og:video', content: correctSrc.value },
      {
        property: 'og:image',
        content: `${useHostApp()}${lecture.value?.image?.src}`,
      },
      {
        name: 'description',
        content:
          'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
      },
      {
        property: 'og:description',
        content:
          'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href:
          `${useHostApp()}/watch/lectures/${lecture.value?.slug}` ||
          `${useHostApp()}${route.path}`,
      },
    ],
  })),
);

useSchemaOrg(() =>
  defineWebPage({
    '@type': 'VideoObject',
    uploadDate: new Date(lecture.value?.published_at),
    duration: secondsToISO(lecture.value?.duration),
    contentUrl: lecture.value?.video_code,
    thumbnailUrl: `${useHostApp()}${lecture.value?.image?.src}`,
    publisher: {
      '@type': 'Organization',
      '@id': lecture.value?.entity_source?.url,
      name: lecture.value?.entity_source?.name,
      url: lecture.value?.entity_source?.url,
    },
  }),
);
</script>

<style scoped>
.highlight {
  -webkit-tap-highlight-color: #0000;
}
</style>
